'use strict';

intellidealerAppCoreModule.factory('equipmentCustomerHistoryResource', function ($resource, appConfigurationService) {
  return {
    equipmentCustomerHistory: $resource(appConfigurationService.basePath + '/rest/equipmentcustomerhistory/getEquipmentCustomerHistory')
  }
});
